import React, { useState } from "react";
import { Container, Form, Button } from "react-bootstrap";
import "./Register.css";
import illustration from "../../../assets/ilustracao.png";
import logo from "../../../assets/Logo.png";
import { register } from "../../../api/auth/register";
import { useNavigate } from "react-router-dom";
import formatPhone from "../../../utils/formatPhone";
import FlashMessage from "../../../components/common/FlashMessage";
import { useFlashMessage } from "../../../hooks/useFlashMessage";

interface RegisterProps {
  onNavigate?: () => void;
}

const RegisterPage: React.FC<RegisterProps> = ({ onNavigate }) => {
  const navigate = useNavigate();
  const { message, type, showMessage, clearMessage } = useFlashMessage(5000);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      showMessage("As senhas devem ser iguais!", "warning");
      return;
    }

    setLoading(true);
    const numero = phone.replace(/\D/g, "");
    register({
      nome_completo: name,
      email: email,
      senha: password,
      telefone: numero,
    })
      .then(() => {
        showMessage("Verifique sua conta no seu e-mail!", "success");
        setTimeout(() => navigate("/login"), 2000);
      })
      .catch((error) => {
        if (error.isRateLimited) {
          showMessage(error.userMessage, "warning");
        } else if (error?.response?.status === 400) {
          const msg =
            error.response?.data?.message ||
            error.response?.data?.error ||
            JSON.stringify(error.response?.data);
          showMessage(`Dados inválidos: ${msg}`, "error");
        } else {
          showMessage(
            "Falha ao registrar, tente novamente mais tarde ou contate o suporte.",
            "error"
          );
        }
        setLoading(false);
      });
  };

  return (
    <Container fluid className="login-container">
      {message && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            minWidth: "400px",
          }}
        >
          <FlashMessage message={message} type={type} onClose={clearMessage} />
        </div>
      )}
      <div className="left-section">
        <div className="branding">
          {
            <img
              src={logo}
              alt="Logo"
              className="logo"
              width={55}
              height={55}
              onClick={() => navigate("/home")}
            />
          }
          <span className="brand-name">Insecta</span>
        </div>

        <div className="login-content">
          <h1 className="title">Cadastrar</h1>
          <h2 className="title">
            Preencha suas
            <br />
            informações para se
            <br />
            juntar a nós.
          </h2>

          <p className="title">
            Se você já tem uma conta, você pode
            <br />
            fazer{" "}
            <a href="/login" className="register-link" onClick={onNavigate}>
              login aqui!
            </a>
          </p>
        </div>

        <div className="illustration-container">
          {<img src={illustration} alt="Ilustração" className="illustration" />}
        </div>
      </div>

      <div className="right-section">
        <div className="form-container">
          <p className="form-title">Insira suas informações abaixo</p>
          <Form onSubmit={handleSubmit} className="login-form">
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Insira o e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Nome"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="tel"
                placeholder="Número de telefone"
                value={phone}
                onChange={(e) => setPhone(formatPhone(e.target.value))}
                required
                className="form-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Confirmar senha"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className="form-input"
              />
            </Form.Group>

            <Button type="submit" className="login-button" disabled={loading}>
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ width: "1rem", height: "1rem" }}
                ></span>
              ) : (
                "Registrar"
              )}
            </Button>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default RegisterPage;
